var render = function render(){var _vm=this,_c=_vm._self._c;return _c('remediation-instruction-executions-list',{attrs:{"executions":_vm.executions,"options":_vm.options,"total-items":_vm.meta.total_count,"pending":_vm.pending},on:{"update:options":function($event){_vm.options=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }